export const SET_OPEN_TASKS_LIST = "SET_OPEN_TASKS_LIST";
export const SET_TASK_DETAILS = "SET_TASK_DETAILS";
export const SET_MY_DAY_LIST = "SET_MY_DAY_LIST";
export const SET_YESTERDAY_LIST = "SET_YESTERDAY_LIST";
export const SET_DEPENDENCY_LIST = "SET_DEPENDENCY_LIST";
export const SET_MY_DEPENDENCY_LIST = "SET_MY_DEPENDENCY_LIST";
export const SET_ASSIGNED_BY_ME_LIST = "SET_ASSIGNED_BY_ME_LIST";
export const SET_DELAY_REASONS_LIST = "SET_DELAY_REASONS_LIST";
export const SET_TASK_PLANNER_STATUS_LIST = "SET_TASK_PLANNER_STATUS_LIST";
export const SET_TASK_WORK_LOG = "SET_TASK_WORK_LOG";
export const SET_TASK_PLANNER_REASONS_LIST = "SET_TASK_PLANNER_REASONS_LIST";
export const SET_TASK_TYPE_LIST = "SET_TASK_TYPE_LIST";
export const SET_MY_DAY_WISE_HOURS_LIST = "SET_MY_DAY_WISE_HOURS_LIST";
export const SET_MY_DAY_HEADER_COUNT = "SET_MY_DAY_HEADER_COUNT";
export const SET_MY_OPEN_TASK_HEADER_COUNT = "SET_MY_OPEN_TASK_HEADER_COUNT";
export const SET_PLAN_LIST = "SET_PLAN_LIST";
export const SET_CALENDAR_PLAN_DATA = "SET_CALENDAR_PLAN_DATA";
export const SET_USER_LIST = "SET_USER_LIST";
export const SET_PROJECT_LIST = "SET_PROJECT_LIST";
export const SET_MY_TEAM_LIST = "SET_MY_TEAM_LIST";
export const SET_MY_TEAM_PLANNED_HOURS_LIST = "SET_MY_TEAM_PLANNED_HOURS_LIST";
export const SET_MY_TEAM_LOG_WORK_LIST = "SET_MY_TEAM_LOG_WORK_LIST";
export const SET_TASK_ATTACHMENT_LIST = "SET_TASK_ATTACHMENT_LIST";
export const SET_LOG_WORK_LIST = "SET_LOG_WORK_LIST";
export const SET_VIEWING_EMPLOYEE = "SET_VIEWING_EMPLOYEE";
export const SET_MY_TEAM_EMPLOYEE_DROPDOWN = "SET_MY_TEAM_EMPLOYEE_DROPDOWN";
export const SET_MY_TEAM_DIVISION_LIST = "SET_MY_TEAM_DIVISION_LIST";
export const SET_MY_TEAM_MANAGER_LIST = "SET_MY_TEAM_MANAGER_LIST";
export const SET_USER_LIST_BY_PROJECT = "SET_USER_LIST_BY_PROJECT";
export const SET_PROJECT_CALENDAR_DATA = "SET_PROJECT_CALENDAR_DATA";
export const SET_PROJECT_TOTAL_HOURS = "SET_PROJECT_TOTAL_HOURS";
export const SET_PERSONAL_INSIGHTS_TILE_DATA = "SET_PERSONAL_INSIGHTS_TILE_DATA";
export const SET_PLANNING_TREND = "SET_PLANNING_TREND";
export const SET_PLAN_VS_LOG_TREND = "SET_PLAN_VS_LOG_TREND";
export const SET_DEPENDENCY_HANDLING_TREND = "SET_DEPENDENCY_HANDLING_TREND";
export const SET_LEVEL_WISE_LOGGED_HOURS = "SET_LEVEL_WISE_LOGGED_HOURS";
export const SET_CLUSTER_ANALYSIS_LIST = "SET_CLUSTER_ANALYSIS_LIST";
export const SET_CLUSTER_ALLOCATIONS_LIST = "SET_CLUSTER_ALLOCATIONS_LIST";
